import graphqlClient from '~/graphql/graphqlClient';

export type CavernsUpdateUnitsArgs = {
  playerId: string;
  game_submode: string;
  allUnits: any;
};

export type CavernsUpdateUnitsResult = {
  success: boolean;
};

const mutation = `
mutation CavernsUpdateUnits(
  $playerId: String!
  $game_submode: String!
  $allUnits: JSON!
) {
  cavernsUpdateUnits(
    playerId: $playerId
    game_submode: $game_submode
    allUnits: $allUnits
  ) {
    success
  }
}`;

export default async function mutationCavernsUpdateUnits(
  args: CavernsUpdateUnitsArgs
): Promise<CavernsUpdateUnitsResult | undefined> {
  return await graphqlClient.request<CavernsUpdateUnitsResult>('cavernsUpdateUnits', mutation, args);
}
